export default {
  namespaced: true,
  state: {
    bannerList: [],
    tabList: [],
    enterprise: "",
    questionDoc: "",
    reportBanner: [],
    pageTitle: "",
    token: "",
    gptToken: ""
  },
  getters: {
    bannerList: state => state.mystate.bannerList,
    tabList: state => state.mystate.tabList,
    enterprise: state => state.mystate.enterprise,
    questionDoc: state => state.mystate.questionDoc,
    reportBanner: state => state.mystate.reportBanner,
    pageTitle: state => state.mystate.pageTitle,
    token: state => state.mystate.token,
    gptToken: state => state.mystate.gptToken,
  },
  mutations: { //同步的更改数据
    setBannerList(state, bannerList) {
      state.bannerList = bannerList
      localStorage.setItem('bannerList', JSON.stringify(bannerList));
    },
    setTabList(state, tabList) {
      state.tabList = tabList
      localStorage.setItem('tabList', JSON.stringify(tabList));
    },
    setEnterprise(state, enterprise) {
      state.enterprise = enterprise
      localStorage.setItem('enterprise', enterprise);
    },
    setQuestionDoc(state, questionDoc) {
      state.questionDoc = questionDoc
      localStorage.setItem('questionDoc', questionDoc);
    },
    setReportBanner(state, reportBanner) {
      state.reportBanner = reportBanner
      localStorage.setItem('reportBanner', JSON.stringify(reportBanner));
    },
    setPageTitle(state, pageTitle) {
      state.pageTitle = pageTitle
      localStorage.setItem('pageTitle', pageTitle);
    },
    setToken(state, token) {
      state.token = token
      localStorage.setItem('token', token);
    },
    setGptToken(state, gptToken) {
      state.gptToken = gptToken
      localStorage.setItem('gptToken', gptToken);
    }
  },
}


// WEBPACK FOOTER //
// ./src/store/modules/mystate.js